"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParams = exports.keys = void 0;
const zustand_1 = __importDefault(require("zustand"));
const middleware_1 = require("zustand/middleware");
const defaultParmas = __importStar(require("../parameters"));
exports.keys = Object.keys(defaultParmas);
exports.useParams = (0, zustand_1.default)(
// @ts-ignore
middleware_1.persist(set => ({
    parameters: Object.assign({}, defaultParmas),
    changeParams: ({ param, amount, color, }) => set(state => {
        if (amount) {
            return {
                parameters: Object.assign(Object.assign({}, state.parameters), { [param]: amount }),
            };
        }
        if (color) {
            return {
                parameters: Object.assign(Object.assign({}, state.parameters), { [param]: color }),
            };
        }
        return state;
    }),
})));
